import { render, staticRenderFns } from "./listPincodes.vue?vue&type=template&id=13aab1e3"
import script from "./listPincodes.vue?vue&type=script&lang=js"
export * from "./listPincodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports